import State from '../core/State';
import initialState from '../initialState';
import produce, { Draft } from 'immer';
import SpeculationRule from '../entity/SpeculationRule';

export const startFetchingSpeculationRule = () =>
  produce((draft: Draft<State>) => {
    draft.speculationRule.fetching = draft.speculationRule.fetching + 1;
  });

export const setSpeculationRule = (speculationRule: SpeculationRule) =>
  produce((draft: Draft<State>) => {
    draft.speculationRule.data = speculationRule;
  });

export const finishFetchingSpeculationRule = () =>
  produce((draft: Draft<State>) => {
    draft.speculationRule.fetching = draft.speculationRule.fetching - 1;
  });

export const disposeSpeculationRule = () =>
  produce((draft: Draft<State>) => {
    draft.speculationRule.data = initialState.speculationRule.data;
    draft.speculationRule.fetching = initialState.speculationRule.fetching;
  });
